<!--suppress HtmlUnknownBooleanAttribute, AngularUndefinedBinding -->
<div class="row">
  <div class="col-12 col-md-10">
    <nav class="breadcrumb-one" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="javascript:void(0);">
            <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
          </a>
        </li>
        <li class="breadcrumb-item">
          <a [routerLink]="'/private/affiliate'" translate>Affiliate Marketing</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page" translate>Withdrawal History</li>
      </ol>
    </nav>
  </div>
</div>

<div [hidden]="loading" class="col-xl-12 col-lg-12 col-sm-12 layout-spacing">
  <div class="widget-content widget-content-area br-6">
    <div class="table-responsive mb-4 mt-4">
      <table id="withdraw-history" class="table table-hover" style="width:100%">
        <thead>
        <tr>
          <th translate>ID</th>
          <th translate>Amount</th>
          <th translate>Status</th>
          <th translate>Request Date</th>
          <th translate>Processed Date</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngIf="withdrawRequests == null || withdrawRequests.length == 0">
          <td colspan="5" style="text-align: center; font-size: 12pt; color: cadetblue">
            {{ 'No withdrawal requests found' | translate }}
          </td>
        </tr>
        <tr *ngFor="let request of withdrawRequests">
          <!-- ID -->
          <td>
            <span>{{ request.id }}</span>
          </td>
          <!-- Amount -->
          <td>
            <span>{{ request.amount | number:'1.2-2' }}</span>
          </td>
          <!-- Status -->
          <td>
            <span [ngClass]="getStatusClass(request.status)">{{ request.status | translate }}</span>
          </td>
          <!-- Request Date -->
          <td>
            <span>{{ request.requestDate | date:'y/M/d' }}</span>
          </td>
          <!-- Processed Date -->
          <td>
            <span *ngIf="request.processedDate">{{ request.processedDate | date:'y/M/d' }}</span>
            <span *ngIf="!request.processedDate">-</span>
          </td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <th translate>ID</th>
          <th translate>Amount</th>
          <th translate>Status</th>
          <th translate>Request Date</th>
          <th translate>Processed Date</th>
        </tr>
        </tfoot>
      </table>

      <!-- Add this before the closing </div> of the table-responsive section -->
      <div class="d-flex justify-content-between mt-4" *ngIf="totalPages > 1">
        <div>
          <span translate>Showing</span> {{ currentPage * pageSize + 1 }} - {{ (currentPage + 1) * pageSize > totalItems ? totalItems : (currentPage + 1) * pageSize }} <span translate>of</span> {{ totalItems }} <span translate>entries</span>
        </div>
        <nav aria-label="Page navigation">
          <ul class="pagination">
            <li class="page-item" [class.disabled]="currentPage === 0">
              <a class="page-link" href="javascript:void(0);" (click)="changePage(0)" aria-label="First">
                <span aria-hidden="true">&laquo;&laquo;</span>
              </a>
            </li>
            <li class="page-item" [class.disabled]="currentPage === 0">
              <a class="page-link" href="javascript:void(0);" (click)="changePage(currentPage - 1)" aria-label="Previous">
                <span aria-hidden="true">&laquo;</span>
              </a>
            </li>
            <ng-container *ngFor="let page of [].constructor(totalPages > 5 ? 5 : totalPages); let i = index">
              <li class="page-item"
                  *ngIf="i >= currentPage - 2 && i <= currentPage + 2"
                  [class.active]="currentPage === i">
                <a class="page-link" href="javascript:void(0);" (click)="changePage(i)">{{ i + 1 }}</a>
              </li>
            </ng-container>
            <li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
              <a class="page-link" href="javascript:void(0);" (click)="changePage(currentPage + 1)" aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
              </a>
            </li>
            <li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
              <a class="page-link" href="javascript:void(0);" (click)="changePage(totalPages - 1)" aria-label="Last">
                <span aria-hidden="true">&raquo;&raquo;</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>

    </div>
    <div class="row mb-4">
      <div class="col-12">
        <button class="btn btn-primary" [routerLink]="'/private/affiliate'" translate>Back</button>
      </div>
    </div>
  </div>
</div>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
